// SolutionBlock.jsx
import { useState, useRef, useEffect } from "react";
import { useQuestions } from "../../QuestionStore";

export function SolutionBlock() {
  const { setQuestionTime, setQuestionHint, getCurrentQuestion } = useQuestions();

  const q = getCurrentQuestion();
  const [timeLimited, setTimeLimited]   = useState(q?.time != null);
  const [seconds, setSeconds]           = useState(q?.time ?? 180);
  const [hint, setHint]                 = useState(q?.solution?.hint ?? "");
  const hintRef = useRef(null);

  // sync if question changes (navigating prev/next)
  useEffect(() => {
    const q = getCurrentQuestion();
    const hasTime = q?.time != null;
    setTimeLimited(hasTime);
    setSeconds(q?.time ?? 180);
    setHint(q?.solution?.hint ?? "");
    if (hintRef.current) hintRef.current.value = q?.solution?.hint ?? "";
  }, [q?.ind]);

  const handleToggleTime = () => {
    const next = !timeLimited;
    setTimeLimited(next);
    setQuestionTime(next, seconds);
  };

  const handleSecondsChange = (e) => {
    const val = parseInt(e.target.value) || null;
    setSeconds(val);
    if (timeLimited) setQuestionTime(true, val);
  };

  const handleHintBlur = (e) => {
    setQuestionHint(e.target.value);
  };

  return (
    <div style={{
      width: "100%",
      boxSizing: "border-box",
      borderRadius: 10,
      background: "#ffffff",
      border: "1.5px solid #e8e8e8",
      boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
      overflow: "hidden",
    }}>

      {/* ── Top bar: time toggle ── */}
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "10px 16px",
        borderBottom: "1px solid #f0f0f0",
        background: "#fafafa",
      }}>
        {/* Radio-style toggle */}
        <div
          onClick={handleToggleTime}
          style={{
            width: 18, height: 18,
            borderRadius: "50%",
            border: `2px solid ${timeLimited ? "#4285F4" : "#bbb"}`,
            background: timeLimited ? "#4285F4" : "#fff",
            cursor: "pointer",
            flexShrink: 0,
            display: "flex", alignItems: "center", justifyContent: "center",
            transition: "all 0.15s",
          }}
        >
          {timeLimited && (
            <div style={{
              width: 7, height: 7,
              borderRadius: "50%",
              background: "#fff",
            }} />
          )}
        </div>

        <span
          onClick={handleToggleTime}
          style={{
            fontSize: 13,
            color: timeLimited ? "#2d2d2d" : "#aaa",
            cursor: "pointer",
            userSelect: "none",
            fontFamily: "'Nunito', sans-serif",
          }}
        >
          Time limit
        </span>

        {/* Seconds input — only visible when toggled on */}
        {timeLimited && (
          <div style={{ display: "flex", alignItems: "center", gap: 5, marginLeft: 6 }}>
            <input
              type="number"
              min={1}
              max={7200}
              value={seconds}
              onChange={handleSecondsChange}
              style={{
                width: 64,
                fontSize: 13,
                border: "1px solid #d0d0d0",
                borderRadius: 6,
                padding: "3px 8px",
                background: "#fff",
                color: "#333",
                outline: "none",
                fontFamily: "'Nunito', sans-serif",
              }}
            />
            <span style={{ fontSize: 12, color: "#888", fontFamily: "'Nunito', sans-serif" }}>
              sec
            </span>
          </div>
        )}
      </div>

      {/* ── Hint / answer textarea ── */}
      <div style={{ padding: "12px 16px 14px 16px" }}>
        <label style={{
          fontSize: 11,
          color: "#999",
          fontFamily: "'Nunito', sans-serif",
          letterSpacing: "0.04em",
          display: "block",
          marginBottom: 6,
        }}>
          ANSWER / HINT
        </label>
        <textarea
          ref={hintRef}
          defaultValue={hint}
          onBlur={handleHintBlur}
          placeholder="Hint for AI Correct the answer…"
          rows={4}
          style={{
            width: "100%",
            boxSizing: "border-box",
            fontSize: 15,
            lineHeight: 1.6,
            color: "#2d2d2d",
            fontFamily: "'Georgia', serif",
            border: "1.5px dashed #ddd",
            borderRadius: 7,
            padding: "10px 12px",
            resize: "vertical",
            outline: "none",
            background: "#fdfdfd",
          }}
        />
      </div>
    </div>
  );
}